import React from 'react'
import { Icon, EidLogoIcon } from 'packages/eid-icons'
import { Header, Tooltip } from 'packages/eid-ui'
import { styled, Typography, Link, Box } from '@mui/material'
import LanguageMenu from './LanguageMenu'
import AccountDropdown from './AccountDropdown'
import { useTranslation } from 'react-i18next'
import appWindowConfig from 'config'
import { useCommonGetAPI } from 'hooks'

const StyledChip = styled('div')({
    position: 'absolute',
    top: '0px',
    left: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ff6100 !important',
    color: '#ffffff',
    height: '13px',
    maxWidth: '45px',
    minWidth: '24px',
    transform: 'skew(-20deg)',
    borderRadius: '2px',
    '@media (max-width:374px)': {
        display: 'none',
    },
})

const itemStyles = {
    minWidth: '30px',
    padding: '0px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const MobileHeader = ({ handleSearch, config }) => {
    const { t } = useTranslation()

    const { data: environmentData } = useCommonGetAPI(
        config.showEnvironment ? '/api/Application/EnvironmentName' : null,
    )

    return (
        <Header.Mobile
            bgColor={config.bgColor}
            data-ai-explain="Header: mobile"
            data-ai-explain-section="header"
        >
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                }}
            >
                <Link
                    href={`${appWindowConfig.APP_SUBPATH}/`}
                    underline="none"
                    aria-label={
                        config.appLogo?.name ||
                        config.appTitle?.value ||
                        t('Home')
                    }
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    data-ai-explain="App logo link"
                >
                    <Header.Item style={{ ...itemStyles, padding: 0 }}>
                        {config.appLogo.type === 'base64' ? (
                            <img
                                style={config.appLogo.style}
                                src={config.appLogo.value}
                                alt={config.appLogo.name}
                            />
                        ) : config.showEidLogo ? (
                            <EidLogoIcon />
                        ) : (
                            <Icon
                                style={config.appLogo.style}
                                name={config.appLogo.value}
                            />
                        )}
                    </Header.Item>
                </Link>
                {environmentData?.environmentName && (
                    <Box position="relative" width="32px">
                        <Tooltip title={environmentData?.environmentName}>
                            <StyledChip>
                                <Typography
                                    noWrap
                                    style={{
                                        fontSize: '8px',
                                        padding: '0px 1.5px',
                                    }}
                                >
                                    {environmentData?.environmentName}
                                </Typography>
                            </StyledChip>
                        </Tooltip>
                    </Box>
                )}

                <Header.RightSection>
                    <Header.Item style={itemStyles}>
                        <LanguageMenu
                            showCone={false}
                            anchorPosition={{
                                right: '-32px',
                                top: '54px',
                            }}
                        />
                    </Header.Item>

                    <Header.Item style={itemStyles}>
                        <AccountDropdown />
                    </Header.Item>
                </Header.RightSection>
            </div>

            {config.search?.show && handleSearch && (
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <Header.Search
                        styleData={config.search?.style}
                        placeholder={t('Search')}
                        handleSearch={handleSearch}
                    />
                </div>
            )}
        </Header.Mobile>
    )
}
export default MobileHeader
